const newNote = [
  "M12.05 1.75a1 1 0 0 0-1 1v1.5H9.1a1 1 0 0 0-1 1 1 1 0 0 0 1 .99h1.95v1.5a1 1 0 0 0 1 1 1 1 0 0 0 1-1v-1.5H15a1 1 0 0 0 1-1 1 1 0 0 0-1-.99h-1.95V2.74a1 1 0 0 0-1-.99zM5.4 4.23l-3.23.01c-1.12 0-2.17.83-2.17 2v6.01c0 1.17 1.05 2 2.17 2h8.72c1.11 0 2.16-.83 2.16-2V9.98a1 1 0 0 0-1-1 1 1 0 0 0-1 1v2.27c0-.06 0 .01-.16.01H2.17c-.17 0-.16-.07-.16 0V6.23c0 .07-.01 0 .16 0h4.49a1 1 0 0 0 1-1 1 1 0 0 0-1-1H5.4z"
];
export {
  newNote
};
//# sourceMappingURL=newNote.js.map
